<template lang="pug">
.contentContainer
    h1.TitleU {{name}}
    .textSize(data-aos="fade-up")
        p.textSize(v-for="text in panels[year].texts") {{text}}
        ul
            li.textSize(v-for="li in panels[year].lis") {{li}}


</template>

<script>
export default {
    props: ['year'],
    data () {
        return {
            name: "PANEL DISCUSSION",
            panels: {
                2022: {
                    texts: ['Panel Discussion: The Future Trends in VR/AR Interactions','Panelists:'],
                    lis: []
                },
                2021: {
                    texts: ['Panel Discussion: The Future Trends in VR/AR Interactions','Panelists:'],
                    lis: ['Andrea Bianchi (KAIST)','Liwei Chan (National Yang Ming Chiao Tung University)','Min-Chun Hu (National Tsing Hua University)','Ray Lee (CORMA New Media)']
                }
            }
        }
    },
    methods: {

    }
}
</script>

<style lang="sass" scoped>
@import "@/style/value.sass"
.textSize
    font-size: 18px
li
    line-height: 24px
</style>



// WEBPACK FOOTER //
// src/components/mainPage/Panel.vue